import React from 'react';

// DomainCard Component - Extracted from App.js for better maintainability
// Displays individual domain cards with title, icon, and percentage

const DomainCard = ({ domain, onDomainSelect }) => {
  return (
    <div
      key={domain.id}
      className="border rounded-lg p-6 hover:shadow-lg transition-shadow cursor-pointer"
      onClick={() => onDomainSelect(domain.id)}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className={`w-12 h-12 ${domain.color} rounded flex items-center justify-center text-white text-xl font-bold`}>
            {domain.id}
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-800">{domain.title}</h3>
          </div>
        </div>
        <div className="text-right">
          <span className={`inline-block px-3 py-1 rounded-full text-white text-sm font-semibold ${domain.color}`}>
            {domain.percentage}
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(DomainCard);